import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=66bd234c&scoped=true&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"
import style0 from "./spinner.scss?vue&type=style&index=0&id=66bd234c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd234c",
  null
  
)

export default component.exports